
import { defineComponent, PropType } from 'vue'
import { VulnerabilitySeverity } from '~/types/types'
import { severityIconMap, severityIconModifiedByAIMap } from '~/utils/dependencies'

export default defineComponent({
  name: 'SeverityIndicator',
  props: {
    severity: {
      type: String as PropType<VulnerabilitySeverity> | undefined,
      default: VulnerabilitySeverity.None
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    isOverridden: {
      type: Boolean,
      default: true
    },
    iconSize: {
      type: String,
      default: 'x-small.5'
    }
  },
  data() {
    return {
      severityIconMap,
      VulnerabilitySeverity
    }
  },
  computed: {
    label(): string {
      if (this.severity === undefined) return 'None'
      return {
        [VulnerabilitySeverity.Critical]: 'Critical',
        [VulnerabilitySeverity.High]: 'High',
        [VulnerabilitySeverity.Medium]: 'Medium',
        [VulnerabilitySeverity.Low]: 'Low',
        [VulnerabilitySeverity.None]: 'None'
      }[this.severity]
    },
    SEVERITY_ICON_MAP() {
      return this.isOverridden ? severityIconModifiedByAIMap : severityIconMap
    }
  }
})
